import { create } from 'zustand'

type PacerState = {
  active: boolean
  exhaling: boolean
  start: () => void
  stop: () => void
}

let timer: number | null = null
let phaseTimer: number | null = null

/** Дыхательный пейсер в шапке практики: вдох 3.8с → выдох 6с. */
export const usePacer = create<PacerState>((set) => ({
  active: false,
  exhaling: false,
  start: () => {
    if (timer) return
    const cycle = () => {
      set({ exhaling: false })
      phaseTimer = window.setTimeout(() => set({ exhaling: true }), 3800)
    }
    set({ active: true })
    cycle()
    timer = window.setInterval(cycle, 9800)
  },
  stop: () => {
    if (timer) window.clearInterval(timer)
    if (phaseTimer) window.clearTimeout(phaseTimer)
    timer = null
    phaseTimer = null
    set({ active: false, exhaling: false })
  },
}))
